import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FcDeadlineContractOutlinedSelectModule } from '@core/components/fc-select/search-one/fc-deadline-contract-outlined-select/fc-deadline-contract-outlined-select.module';
import { AddressModule } from '@core/components/inputs/address/address.module';
import { AssigneesComponentModule } from '@core/components/inputs/assignees/assignees.module';
import { CompaniesComponentModule } from '@core/components/inputs/companies/companies.module';
import { EquipmentsComponentModule } from '@core/components/inputs/equipments/equipments.module';
import { LocationsComponentModule } from '@core/components/inputs/locations/locations.module';
import { MaintenanceTypeModule } from '@core/components/inputs/maintenance-type/maintenance-type.module';
import { ProblemsModule } from '@core/components/inputs/problems/problems.module';
import { RequestersComponentModule } from '@core/components/inputs/requesters/requesters.module';
import { SegmentsModule } from '@core/components/inputs/segments/segments.module';
import { StatusModule } from '@core/components/inputs/status/status.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { ScheduleSuggestionsModule } from 'app/main/maintenances/components/schedule-suggestions/schedule-suggestions.module';
import { NgxMaskModule } from 'ngx-mask';
import { DirectivesModule } from '../../../../../../core/directives/directives.module';
import { InfoBannerModule } from './components/info-banner/info-banner.module';
import { DialogStopSchedulingSuggestionsComponent } from './dialog-stop-scheduling-suggestions/dialog-stop-scheduling-suggestions.component';
import { TabMaintenanceComponent } from './tab-maintenance.component';

@NgModule({
  entryComponents: [
    TabMaintenanceComponent,
    DialogStopSchedulingSuggestionsComponent
  ],
  declarations: [
    TabMaintenanceComponent,
    DialogStopSchedulingSuggestionsComponent
  ],
  imports: [
    TranslateModule,

    FuseSharedModule,

    MatIconModule,
    MatToolbarModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatTabsModule,
    MatTooltipModule,
    MatDatepickerModule,
    NgxMaskModule.forRoot(),
    MatProgressBarModule,

    SegmentsModule,
    ProblemsModule,
    RequestersComponentModule,
    StatusModule,
    AssigneesComponentModule,
    LocationsComponentModule,
    CompaniesComponentModule,
    EquipmentsComponentModule,
    MaintenanceTypeModule,
    DateTimePickerModule,
    AddressModule,
    ScheduleSuggestionsModule,
    InfoBannerModule,
    DirectivesModule,
    FcDeadlineContractOutlinedSelectModule
  ],
  exports: [
    TabMaintenanceComponent
  ]
})
export class TabMaintenanceModule {
}
